module.exports = __webpack_public_path__ + "media/images/401-play-logo-white-67e47230.png";